import React, { FunctionComponent, use, useEffect } from "react";
import styles from "../css/Section6.module.css";
import { Link, useLocation } from "react-router-dom";
import { FormatEng } from "../../svg_groups/format_eng";
import { FormatRo } from "../../svg_groups/format_ro";
import { useSelector } from "react-redux";
import axios from "axios";

const Section6 = () => {
  const language = useSelector((state: any) => state.language.value);

  const location = useLocation();

  useEffect(() => {
    if (location.hash === "#preview") {
      const element = document.getElementById("preview");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  const downloadFragment = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/purchases/download/fragment/${language}`,
        {
          responseType: "blob",
        }
      );

      // Create a blob URL and trigger download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement("a");
      a.href = url;
      // Set filename based on language
      const filename =
        language === "RO" ? "Sinopsis_RO.pdf" : "Synopsis_EN.pdf";
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error.response?.data || error.message);
      alert(error.response?.data?.message || "Failed to download file");
    }
  };

  const viewFragment = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/purchases/download/fragment/${language}`,
        {
          responseType: "blob",
        }
      );

      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/pdf" })
      );
      window.open(url, "_blank");
    } catch (error) {
      console.error(
        "Failed to open PDF:",
        error.response?.data || error.message
      );
      alert(error.response?.data?.message || "Failed to open file");
    }
  };

  return (
    <div className={styles.mainContainer} id="preview">
      <div className={styles.title}>
        <div className={styles.readIntroFragment}>
          {language === "RO" && (
            <>
              <span className={styles.readIntro}>
                Citește sinopsisul și un fragment din cartea{" "}
                <span style={{ color: "#c4b57c", fontFamily: "Lora, serif" }}>
                  “SPIRIT LIBER”
                </span>{" "}
                și lasă povestea să te inspire
              </span>
            </>
          )}
          {language === "EN" && (
            <>
              <span className={styles.readIntro}>
                Read the synopsis and an excerpt from the book
                <span style={{ color: "#c4b57c", fontFamily: "Lora, serif" }}>
                  “SPIRIT LIBER”
                </span>{" "}
                and let the story inspire you
              </span>
            </>
          )}
        </div>
        <span className={styles.readFragment}>
          {language === "RO" &&
            "Citește sinopsisul și un fragment din cartea “SPIRIT LIBER” și lasă povestea să te inspire"}
          {language === "EN" &&
            "Read the synopsis and an excerpt from the book “SPIRIT LIBER” and let the story inspire you"}
        </span>
      </div>
      <div className={styles.noise} />
      <div className={styles.generalGroup}>
        <div className={styles.group}>
          <div className={styles.group1}>
            <div className={styles.devicesAppleIpad}>
              <div className={styles.image} />
            </div>
            <div className={styles.rectangle} />
          </div>
          <div className={styles.group2}>
            <div className={styles.electronicVersion}>
              {language === "RO" && (
                <>
                  <span>
                    Am pregătit un fragment pe care îl ofer gratuit pentru
                    sufletul tău curios. Deschide-l oricând simți nevoia unei
                    doze de inspirație cu aromă de libertate.
                  </span>
                </>
              )}
              {language === "EN" && (
                <>
                  <span>
                    I've prepared an excerpt that I offer for free to your
                    curious soul. Open it whenever you need a dose of
                    inspiration with a flavor of freedom.
                  </span>
                </>
              )}
              <button className={styles.group3} onClick={viewFragment}>
                <div className={styles.button}>
                  <span className={styles.addToCart}>
                    {language === "RO" && (
                      <>
                        <span>Vezi varianta PDF</span>
                      </>
                    )}
                    {language === "EN" && (
                      <>
                        <span>Preview PDF version</span>
                      </>
                    )}
                  </span>
                </div>
              </button>
            </div>
          </div>
        </div>
        {language === "EN" && <FormatEng />}
        {language === "RO" && <FormatRo />}

        <div className={styles.group5}>
          <div className={styles.group2}>
            <div className={styles.electronicVersion}>
              {language === "RO" && (
                <>
                  <span>
                    Alege formatul care ți se potrivește cel mai bine. Aici
                    găsești varianta audio.
                  </span>
                </>
              )}
              {language === "EN" && (
                <>
                  <span>
                    Choose the format that resonates with you the most. Here,
                    you will find the audio version.
                  </span>
                </>
              )}
              <Link to="/preview">
                <button className={styles.group3}>
                  <div className={styles.button}>
                    <span className={styles.addToCart}>
                      {language === "RO" && (
                        <>
                          <span>Ascultă un fragment audio</span>
                        </>
                      )}
                      {language === "EN" && (
                        <>
                          <span>Listen to an audio excerpt</span>
                        </>
                      )}
                    </span>
                  </div>
                </button>
              </Link>
            </div>
          </div>
          <div className={styles.group1}>
            <div className={styles.devicesAppleIpad}>
              <div className={styles.image2} />

              <div className={styles.homeButton} />
            </div>
            <div className={styles.rectangle} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section6;
